import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wj_delete",
  "use": "icon-wj_delete-usage",
  "viewBox": "0 0 16 14.099",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14.099\" id=\"icon-wj_delete\"><defs><style>#icon-wj_delete .a{}</style></defs><path class=\"a\" d=\"M378.6,1054.707a1.235,1.235,0,0,1-1.609,1.873l-5.961-5.124-5.961,5.124a1.235,1.235,0,0,1-1.609-1.873l5.676-4.879-5.676-4.879a1.235,1.235,0,0,1,1.61-1.873l5.961,5.124,5.961-5.124a1.235,1.235,0,0,1,1.61,1.873l-5.676,4.879Z\" transform=\"translate(-363.031 -1042.778)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol